import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '@tasks-web/ui-components';
import { RESOURCE_URL_PATTERN } from '@common/constants';
import { extractApiError } from '@common/utils';

export const forbiddenInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status === 403 &&
        req.method === 'GET' &&
        RESOURCE_URL_PATTERN.test(req.url)
      ) {
        toastService.showError(
          extractApiError(
            error,
            "You don't have permission to access this resource."
          )
        );
        router.navigate(['/home/spaces']);
      }
      return throwError(() => error);
    })
  );
};
